import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=09972a40"
import script from "./project-list.ts?vue&type=script&lang=ts&external"
export * from "./project-list.ts?vue&type=script&lang=ts&external"
import style0 from "./project-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports